import React, { useEffect, useState, useRef } from "react";
import { CiStreamOn } from "react-icons/ci";
import { GiThreeFriends } from "react-icons/gi";
import { FaBasketShopping } from "react-icons/fa6";
import { MdMessage, MdOutlineFeed } from "react-icons/md";
import { useNavigate, useParams, matchPath, useLocation } from "react-router-dom";
import { VideoCardFooterIcons } from "../../assets/data/Datas";
import LocationDetectModal from "../Modals/locationDetectModal";
import Footer from "../footer/Footer";
import { Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import OfflineBanner from "./OfflineBanner";

export default function MobileLayout({ children }) {
    // Detect Chrome on iOS
    const isChromeOniOS = (() => {
        if (typeof navigator === "undefined") return false;
        const ua = navigator.userAgent;
        return /CriOS/i.test(ua) && /iphone|ipad|ipod/i.test(ua);
    })();

    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const [locationDetectorModal, setLocationDetectorModal] = useState(false);
    const location = useLocation();
    const footerRef = useRef(null);
    const auth = useSelector((state) => state.auth);

    // Check authentication status
    useEffect(() => {
        setIsLoggedIn(!!auth.accessToken);
    }, [location.pathname, auth.accessToken]);

    // Expose footer height as CSS variable for in-layout overlays
    useEffect(() => {
        const root = document.getElementById("mobile-layout-root");
        const updateFooterHeight = () => {
            if (root && footerRef.current) {
                root.style.setProperty("--footer-height", `${footerRef.current.offsetHeight}px`);
            }
        };

        updateFooterHeight();
        window.addEventListener("resize", updateFooterHeight);
        return () => window.removeEventListener("resize", updateFooterHeight);
    }, []);

    const handleCheckPath = () => {
        switch (location.pathname) {
            case "/":
                return true;
            default:
                return false;
        }
    };
    const reloadPage = () => {
        navigate("/");
    };

    const handleNavigate = (value) => {
        const replaceValue = value.replaceAll(" ", "");
        switch (replaceValue) {
            case "Neighborhood":
                return navigate(`/neighborhood`);
            case "YourFeed":
                return reloadPage();
            case "YourFriends":
                return reloadPage();
            case "Home":
                return navigate("/");
            case "Createvideo":
                // return openDrawerBottom();
                return navigate(`/create-videos`);
            case "Messages":
                return navigate(`/message`);
            case "Helmet1":
                return navigate(`/commingsoon`);
            case "Account":
                // return openDrawerAccountModal();
                return navigate(`/account`);
            case "Groups":
                return navigate(`/othergroup/list/`);
            default:
                // navigate(`/${replaceValue}`);
                break;
        }
    };

    const url = "https://thtsusa.com/changePassword?uid=YWZlZjIwZDYtOTFmNC00MGFjLTlkMjktMTY0YTM4ODkwYzA4&token=clhh7h-083b60ef8d3e3a59dae6a897cbdec29e";
    //
    const handleCheckPathName = () => {
        const replaceValue = location.pathname;
        // if (uid && token) {
        //     return false;
        // }
        if (matchPath("/signup/verify/:email", replaceValue)) {
            return false
        }
        if (matchPath("/enterotp/:email", replaceValue)) {
            return false
        }
        if (matchPath("/changepassword/:otp/:email", replaceValue)) {
            return false
        } if (matchPath("/help/:id", replaceValue)) {
            return isLoggedIn ? true : false;
        } if (matchPath("/upload-video", replaceValue)) {
            return false
        } if (matchPath("/view-livestream/:streamId", replaceValue)) {
            return false
        }

        // Hide Footer on specific routes
        switch (replaceValue) {
            case "/uploadvideo":
                return false;
            case "/login":
                return false;
            case "/signup":
                return false;
            case "/signup/verify/":
                return false;
            case "/register":
                return false;
            case "/neighborhood":
                return false;
            case "/create-account-with":
                return false;
            case "/create-account/email":
                return false;
            case "/create-account/phone":
                return false;
            case "/user-intrest":
                return false;
            case "/user-intrests":
                return false;
            case "/resetpassword":
                return false;
            case "/password-updated":
                return false;
            case replaceValue?.includes("changePassword"):
                return false;
            case "/":
                return false;
            case "/help":
                return isLoggedIn ? true : false;
            case "/readmore-answer":
                return isLoggedIn ? true : false;
            case "/enterotp":
                return false;
            case "/switch/account":
                return false;
            case "/terms-of-use":
                return isLoggedIn ? true : false;
            case "/privacy-policy":
                return isLoggedIn ? true : false;
            case "/cookies":
                return isLoggedIn ? true : false;
            case "/create-videos":
                return false;
            case "/create-livestream":
                return false;
            case "/livestreams":
                return false;
            default:
                return true;
        }
    };

    const HeaderIcons = [
        {
            icon: (
                <FaBasketShopping
                    color={`${location.pathname === "/mobileMessages" ||
                        location.pathname === "/searchresultpage"
                        ? "white"
                        : "black"
                        }`}
                    className="h-[20px] w-[20px]"
                />
            ),
            placeholder: "Shop",
        },
        {
            icon: (
                <MdMessage
                    color={`${location.pathname === "/mobileMessages" ||
                        location.pathname === "/searchresultpage"
                        ? "white"
                        : "black"
                        }`}
                    className="h-[20px] w-[20px]"
                />
            ),
            placeholder: "Messages",
        },
        {
            icon: (
                <MdOutlineFeed
                    color={`${location.pathname === "/mobileMessages" ||
                        location.pathname === "/searchresultpage"
                        ? "white"
                        : "black"
                        }`}
                    className="h-[20px] w-[20px]"
                />
            ),
            placeholder: "Your Feed",
        },

        {
            icon: (
                <GiThreeFriends
                    color={`${location.pathname === "/mobileMessages" ||
                        location.pathname === "/searchresultpage"
                        ? "white"
                        : "black"
                        }`}
                    className="h-[20px] w-[20px]"
                />
            ),
            placeholder: "Your Friends",
        },
        {
            icon: <CiStreamOn color="green" className="h-[20px] w-[20px]" />,
            placeholder: "Live Stream",
        },
    ];

    return (
        <div id="mobile-layout-root" className="relative h-full w-full" style={{ isolation: 'isolate' }}>
            <OfflineBanner />
            {handleCheckPath() ? (
                <div className="video-card-header top-8 md:top-4">
                    <div className="h-[3%] absolute z-50 w-full flex justify-between px-2">
                        {HeaderIcons.map((item) => (
                            <div
                                key={item.placeholder}
                                className="flex flex-col justify-center items-center"
                                onClick={() => handleNavigate(`${item.placeholder}`)}
                            >
                                <div className="cursor-pointer">{item.icon} </div>
                                <p className={`${location.pathname === "/mobileMessages" ||
                                    location.pathname === "/searchresultpage"
                                    ? "text-[#fff]"
                                    : "text-[#000]"
                                    } cursor-pointer text-[7px] mt-[2px]`
                                }
                                >
                                    {item.placeholder}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                ""
            )}
            <div className={`${handleCheckPathName() ? "h-[88%] relative" : "h-full"}`} >
                <div className="h-full dark:bg-[#1E1D21] flex-grow overflow-y-scroll overflow-hidden no-scrollbar relative">
                    {children}
                </div>
            </div>

            {handleCheckPathName() && (
                <div
                    id="mobile-layout-footer"
                    ref={footerRef}
                    style={{
                        paddingBottom: isChromeOniOS
                            ? "calc(env(safe-area-inset-bottom, 0px) + 0px)"
                            : "env(safe-area-inset-bottom)",
                    }}
                    className="md:absolute fixed bottom-0 w-full h-[12%] bg-[#333333] dark:bg-[#333333] z-10"
                >
                    <Footer
                        isFixedDark={false}
                        handleNavigate={handleNavigate}
                        VideoCardHeaderIcons={VideoCardFooterIcons}
                        setLocationDetectorModal={setLocationDetectorModal}
                    />
                </div>
            )}

            <Toaster position="top-right" />

            {locationDetectorModal && (
                <LocationDetectModal
                    handleClose={setLocationDetectorModal}
                />
            )}
        </div>
    );
}